import React from "react";
import { Box, Container, Link, Typography } from "@mui/material";
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "config";

export default function Footer() {
  return (
    <Box
      component="footer"
      role="contentinfo"
      sx={{
        mt: "auto",
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
        boxShadow: "0px -10px 30px rgba(0,0,0,0.04)",
      }}
    >
      <Box
        sx={{
          height: 3,
          background:
            "linear-gradient(90deg, rgba(31,93,107,0.35) 0%, rgba(55,191,190,0.22) 40%, rgba(31,93,107,0.10) 100%)",
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          py: 2.5,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
            © {new Date().getFullYear()} CalibrateHCM
          </Typography>
          <Typography variant="caption" color="text.secondary">
            All rights reserved.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <Link
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              fontWeight: 800,
              fontSize: 13,
              color: "text.primary",
              "&:hover": { color: "primary.main" },
            }}
          >
            Privacy Policy
          </Link>

          <Box
            aria-hidden
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              bgcolor: "rgba(0,0,0,0.28)",
              display: { xs: "none", sm: "inline-block" },
            }}
          />

          <Link
            href={TERMS_OF_SERVICE_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              fontWeight: 800,
              fontSize: 13,
              color: "text.primary",
              "&:hover": { color: "primary.main" },
            }}
          >
            Terms & Conditions
          </Link>
        </Box>
      </Container>
    </Box>
  );
}
